// @ts-nocheck
/* eslint-disable no-alert, no-console, react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  ShieldCheck, 
  Search, 
  Ban, 
  CheckCircle, 
  ChevronRight,
  ChevronLeft,
  Loader2,
  FileText,
  X,
  Clock,
  UploadCloud,
  Paperclip
} from "lucide-react";

// FIREBASE & CONTEXT
import { collection, query, where, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // 🟢 IMPORTS DO STORAGE
import { db, storage, storageEnvironment } from "../../config/firebase"; // 🟢 IMPORTANDO O STORAGE
import { useAuth } from "../../contexts/AuthContext"; 

const MinhaCarteiraPage = () => {
  const { companyInfo } = useAuth();
  const brandColor = "#00a99d";

  // 🟢 Tipagem inserida para zerar os erros do TypeScript
  const [activeContracts, setActiveContracts] = useState(/** @type {any[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  // 🟢 States de Paginação (Client-side)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // ESTADOS DO MODAL DE ENCERRAMENTO (BLOCO 4)
  const [encerrarModal, setEncerrarModal] = useState({ isOpen: false, contrato: null });
  const [arquivosEncerramento, setArquivosEncerramento] = useState({ boletoComprovante: null, reciboChaves: null });
  const [isProcessingEncerramento, setIsProcessingEncerramento] = useState(false);

  // ============================================================================
  // BUSCA GLOBAL DE DADOS (TRAVA DE SEGURANÇA B2B)
  // ============================================================================
  useEffect(() => {
    if (!companyInfo?.id) return;

    const qContracts = query(
      collection(db, "contratos_ativos"),
      where("companyId", "==", companyInfo.id) 
    );

    const unsubContracts = onSnapshot(qContracts, (snapshot) => {
      const contracts = /** @type {any[]} */ ([]);
      
      snapshot.docs.forEach(docSnap => {
        const data = docSnap.data();
        
        // 🟢 FILTRO DE AUDITORIA: Se o contrato já foi encerrado definitivamente pela Real Benefícios,
        // ele não deve mais aparecer na listagem de Carteira ATIVA da imobiliária.
        if (data.status !== "Contrato Encerrado") {
          contracts.push({
            id: docSnap.id,
            ...data
          });
        }
      });
      
      contracts.sort((a, b) => {
        const dateA = a['dataAtivacao']?.toMillis() || 0;
        const dateB = b['dataAtivacao']?.toMillis() || 0;
        return dateB - dateA;
      });

      setActiveContracts(contracts);
      setLoading(false);
    });

    return () => unsubContracts();
  }, [companyInfo?.id]);

  // Reseta a página ao buscar ou mudar quantidade de itens
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  // ============================================================================
  // LÓGICA DE ENCERRAMENTO DE CONTRATO (BLOCO 4 - COM STORAGE REAL)
  // ============================================================================
  const abrirModalEncerramento = (contrato) => {
    setEncerrarModal({ isOpen: true, contrato });
    setArquivosEncerramento({ boletoComprovante: null, reciboChaves: null });
  };

  const fecharModalEncerramento = () => {
    setEncerrarModal({ isOpen: false, contrato: null });
    setArquivosEncerramento({ boletoComprovante: null, reciboChaves: null });
  };

  const handleFileChange = (e, tipo) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {
      alert("Por favor, selecione apenas arquivos PDF.");
      e.target.value = "";
      return;
    }
    if (file) {
      setArquivosEncerramento(prev => ({ ...prev, [tipo]: file }));
    }
  };

  const confirmarEncerramento = async () => {
    if (!arquivosEncerramento.boletoComprovante || !arquivosEncerramento.reciboChaves) {
      alert("É obrigatório anexar o 'Boleto + Comprovante' e o 'Recibo de Entrega de Chaves'.");
      return;
    }

    setIsProcessingEncerramento(true);

    try {
      const contrato = encerrarModal.contrato;
      const protocoloSafe = (contrato.protocoloOrigem || contrato.id).replace(/\//g, '-');
      const timestamp = Date.now();

      // 1. Definição das Referências no Storage
      const boletoRef = ref(
        storage,
        `garantias/${storageEnvironment}/${companyInfo.id}/${protocoloSafe}/encerramento/${timestamp}_boleto_${arquivosEncerramento.boletoComprovante.name}`
      );
      const reciboRef = ref(
        storage,
        `garantias/${storageEnvironment}/${companyInfo.id}/${protocoloSafe}/encerramento/${timestamp}_recibo_${arquivosEncerramento.reciboChaves.name}`
      );

      // 2. Upload Físico dos Arquivos
      await uploadBytes(boletoRef, arquivosEncerramento.boletoComprovante);
      await uploadBytes(reciboRef, arquivosEncerramento.reciboChaves);

      // 3. Obtenção das URLs Seguras de Download
      const boletoUrl = await getDownloadURL(boletoRef);
      const reciboUrl = await getDownloadURL(reciboRef);

      // 4. Atualização no Firestore com os links reais
      const contratoRef = doc(db, "contratos_ativos", contrato.id);
      await updateDoc(contratoRef, {
        encerramentoSolicitado: true,
        dataSolicitacaoEncerramento: new Date().toISOString(),
        documentosEncerramento: {
          boletoComprovante: {
            nome: arquivosEncerramento.boletoComprovante.name,
            url: boletoUrl
          },
          reciboChaves: {
            nome: arquivosEncerramento.reciboChaves.name,
            url: reciboUrl
          }
        }
      });
      
      fecharModalEncerramento();
    } catch (error) {
      console.error("Erro ao solicitar encerramento e subir arquivos:", error);
      alert("Houve um erro ao processar sua solicitação e enviar os arquivos ao Storage.");
    } finally {
      setIsProcessingEncerramento(false);
    }
  };

  // ============================================================================
  // FILTRO E PAGINAÇÃO
  // ============================================================================
  const filteredContracts = activeContracts.filter(contrato => {
    const searchLower = searchTerm.toLowerCase();
    return (
      contrato.pagador?.nome?.toLowerCase().includes(searchLower) ||
      contrato.pagador?.cpf?.includes(searchTerm) ||
      contrato.protocoloOrigem?.toLowerCase().includes(searchLower)
    );
  });

  const valorTotalGarantido = filteredContracts.reduce((acc, curr) => {
    if (curr.idEncerramentoSolicitado || curr.encerramentoSolicitado) return acc;
    
    const taxa = parseFloat(curr.faturamento?.valorTaxa?.replace(/\./g, '').replace(',', '.') || 0);
    return acc + taxa;
  }, 0);

  // Fatiamento Paginação
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredContracts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredContracts.length / itemsPerPage);

  const nextPage = () => { if (currentPage < totalPages) setCurrentPage(prev => prev + 1); };
  const prevPage = () => { if (currentPage > 1) setCurrentPage(prev => prev - 1); };

  // ============================================================================
  // SKELETON LOADER
  // ============================================================================
  if (loading) {
    return (
      <div className="p-4 sm:p-5 xl:p-8 w-full animate-pulse bg-[#f8fafc] min-h-screen space-y-6">
        <div className="flex items-center gap-4 mb-2">
           <div className="w-14 h-14 bg-slate-200 rounded-2xl shrink-0"></div>
           <div className="space-y-2"><div className="h-6 bg-slate-200 rounded w-64"></div><div className="h-4 bg-slate-200 rounded w-96"></div></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
           <div className="bg-white p-5 rounded-2xl border border-slate-200 h-24 flex items-center justify-between">
              <div className="space-y-2"><div className="h-4 bg-slate-100 rounded w-32"></div><div className="h-6 bg-slate-200 rounded w-16"></div></div>
              <div className="w-12 h-12 bg-slate-100 rounded-full"></div>
           </div>
           <div className="bg-white p-5 rounded-2xl border border-slate-200 h-24 flex items-center justify-between">
              <div className="space-y-2"><div className="h-4 bg-slate-100 rounded w-32"></div><div className="h-6 bg-slate-200 rounded w-24"></div></div>
              <div className="w-12 h-12 bg-slate-100 rounded-full"></div>
           </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="bg-slate-50 border-b border-slate-200 h-16"></div>
          {Array(5).fill(0).map((_, i) => (
            <div key={i} className="flex justify-between items-center p-6 border-b border-slate-50">
              <div className="space-y-2"><div className="h-4 bg-slate-200 rounded w-24"></div><div className="h-3 bg-slate-100 rounded w-16"></div></div>
              <div className="space-y-2"><div className="h-4 bg-slate-200 rounded w-48"></div><div className="h-3 bg-slate-100 rounded w-32"></div></div>
              <div className="space-y-2"><div className="h-4 bg-slate-200 rounded w-20"></div><div className="h-4 bg-slate-100 rounded w-16"></div></div>
              <div className="h-6 bg-slate-200 rounded-full w-28"></div>
              <div className="h-8 bg-slate-200 rounded w-24"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-5 xl:p-8 w-full font-sans animate-fade-in bg-[#f8fafc] min-h-full space-y-6 relative">
      
      {/* BREADCRUMB E HEADER */}
      <div className="mb-2">
        <div className="flex items-center text-sm text-slate-500 font-medium mb-2">
          <Link to="/dashboard" className="hover:text-teal-600 transition-colors">Dashboard</Link>
          <ChevronRight className="w-4 h-4 mx-1" />
          <span className="text-slate-800 font-semibold">Minha Carteira</span>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-teal-50 flex items-center justify-center shrink-0 border border-teal-100/60 shadow-sm">
              <ShieldCheck className="w-7 h-7" style={{ color: brandColor }} />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 tracking-tight">
                Minha Carteira Ativa
              </h1>
              <p className="text-sm font-medium text-slate-500 mt-1">
                Gestão completa dos seus inquilinos com garantias vigentes.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CARDS DE RESUMO RÁPIDO */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500">Contratos Vigentes</p>
            <h3 className="text-2xl font-bold text-slate-800 mt-1">
              {filteredContracts.filter(c => !c.encerramentoSolicitado && !c.idEncerramentoSolicitado).length}
            </h3>
          </div>
          <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
            <FileText className="w-6 h-6 text-blue-600" />
          </div>
        </div>
        <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500">Volume Total Vigente</p>
            <h3 className="text-2xl font-bold text-slate-800 mt-1">
              {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorTotalGarantido)}
            </h3>
          </div>
          <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-emerald-600" />
          </div>
        </div>
      </div>

      {/* ÁREA DE BUSCA E TABELA */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden flex flex-col">
        
        {/* BARRA DE PESQUISA */}
        <div className="p-4 xl:p-5 border-b border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-4 bg-slate-50/50 shrink-0">
          <div className="relative w-full sm:max-w-md">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="w-4 h-4 text-slate-400" />
            </div>
            <input 
              type="text"
              placeholder="Buscar por nome do inquilino, CPF ou protocolo..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-shadow"
            />
          </div>
        </div>

        {/* TABELA DE CONTRATOS (PAGINADA) */}
        <div className="overflow-x-auto min-h-[400px] flex-1">
          <table className="w-full text-left border-collapse whitespace-nowrap">
            <thead>
              <tr className="text-xs font-semibold text-slate-500 border-b border-slate-100 bg-white uppercase tracking-wider">
                <th className="px-6 py-4">Protocolo / Data</th>
                <th className="px-6 py-4">Locatário Pagador</th>
                <th className="px-6 py-4">Valor (Mensal)</th>
                <th className="px-6 py-4">Status Financeiro</th>
                <th className="px-6 py-4 text-right">Ação</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan={5} className="py-20 text-center">
                    <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-3">
                      <Search className="w-8 h-8 text-slate-300" />
                    </div>
                    <p className="text-slate-800 font-bold text-base">Nenhum contrato encontrado nesta página.</p>
                    <p className="text-slate-500 text-sm mt-1">Tente ajustar os termos da sua pesquisa.</p>
                  </td>
                </tr>
              ) : (
                currentItems.map((contrato) => (
                  <tr key={contrato.id} className={`transition-colors ${contrato.encerramentoSolicitado ? 'bg-slate-50/50 opacity-80' : 'hover:bg-slate-50'}`}>
                    <td className="px-6 py-4">
                      <p className="font-bold text-slate-800 text-sm">{contrato.protocoloOrigem}</p>
                      <p className="text-xs text-slate-500 mt-0.5">
                        {contrato['dataAtivacao'] ? new Date(contrato['dataAtivacao'].toDate()).toLocaleDateString('pt-BR') : "N/A"}
                      </p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="font-semibold text-slate-800 text-sm max-w-[200px] truncate" title={contrato.pagador?.nome}>
                        {contrato.pagador?.nome || "Não informado"}
                      </p>
                      <p className="text-xs text-slate-500 mt-0.5">CPF: {contrato.pagador?.cpf || "N/A"}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="font-bold text-slate-800 text-sm">
                        R$ {contrato.faturamento?.valorTaxa || "0,00"}
                      </p>
                      <span className="inline-block mt-1 px-2 py-0.5 bg-slate-100 text-slate-600 text-[10px] font-bold rounded uppercase">
                        {contrato.faturamento?.formaPagamento || "Mensal"}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      {contrato.encerramentoSolicitado ? (
                        <div className="flex items-center gap-1.5 text-amber-700 bg-amber-50 px-2.5 py-1 rounded-lg border border-amber-200 font-semibold text-xs w-max">
                          <Clock className="w-3.5 h-3.5" /> Encerramento Solicitado
                        </div>
                      ) : (
                        <div className="flex items-center gap-1.5 text-green-700 bg-green-50 px-2.5 py-1 rounded-lg border border-green-200 font-semibold text-xs w-max">
                          <CheckCircle className="w-3.5 h-3.5" /> Ativo e Vigente
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 text-right">
                      {!contrato.idEncerramentoSolicitado && !contrato.encerramentoSolicitado && (
                        <button 
                          className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-bold text-slate-500 hover:text-red-600 bg-slate-50 hover:bg-red-50 border border-slate-200 hover:border-red-200 rounded-lg transition-colors"
                          onClick={() => abrirModalEncerramento(contrato)}
                        >
                          <Ban className="w-3.5 h-3.5" /> Encerrar Contrato
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* 🟢 CONTROLES DE PAGINAÇÃO VIVOS (FOOTER) */}
        {filteredContracts.length > 0 && (
          <div className="p-4 sm:p-5 border-t border-slate-100 bg-slate-50/50 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500 shrink-0">
            <span className="font-medium text-center md:text-left">
              Mostrando <strong className="text-slate-800">{indexOfFirstItem + 1}</strong> a <strong className="text-slate-800">{Math.min(indexOfLastItem, filteredContracts.length)}</strong> de <strong className="text-slate-800">{filteredContracts.length}</strong> contratos
            </span>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
              
              <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm w-full sm:w-auto justify-center">
                <span className="font-medium">Itens:</span>
                <select 
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="bg-transparent border-none font-bold text-teal-600 focus:ring-0 cursor-pointer text-sm outline-none"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              {totalPages > 1 && (
                <div className="flex items-center gap-2 justify-center w-full sm:w-auto">
                  <button 
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm font-bold text-slate-700 px-3 py-1 bg-white border border-slate-200 rounded-lg shadow-sm">
                    {currentPage} / {totalPages}
                  </span>
                  <button 
                    onClick={nextPage}
                    disabled={currentPage >= totalPages}
                    className="p-1.5 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-50 disabled:hover:bg-white transition-colors shadow-sm"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

      </div>

      {/* ========================================================================= */}
      {/* MODAL DE SOLICITAÇÃO DE ENCERRAMENTO (COM STORAGE) */}
      {/* ========================================================================= */}
      {encerrarModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 w-full max-w-lg overflow-hidden relative">
            
            <div className="flex justify-between items-center p-5 border-b border-slate-100 bg-slate-50">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-600">
                  <Ban className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-800">Homologar Encerramento</h3>
                  <p className="text-xs font-medium text-slate-500">
                    Protocolo: {encerrarModal.contrato?.protocoloOrigem}
                  </p>
                </div>
              </div>
              <button 
                onClick={fecharModalEncerramento}
                className="p-2 text-slate-400 hover:text-slate-600 bg-white border border-slate-200 rounded-lg transition-colors"
                disabled={isProcessingEncerramento}
              >
                <X className="w-4 h-4" />
              </button>
            </div>

            <div className="p-6 space-y-5">
              <div className="bg-red-50 border border-red-200 text-red-800 text-sm p-4 rounded-xl font-medium">
                <strong>Aviso Legal:</strong> Ao confirmar o encerramento, a garantia será extinta a partir desta data.
              </div>

              <div className="space-y-4">
                <label className="block text-sm font-semibold text-slate-700">
                  Documentos Obrigatórios <span className="text-red-500">*</span>
                </label>
                
                {/* Boleto + Comprovante */}
                <div className="border border-slate-200 rounded-xl p-4 bg-slate-50 relative group hover:border-brand-primary transition-colors">
                  <label className="flex flex-col text-sm font-semibold text-slate-700 mb-2 cursor-pointer">
                    <span className="flex items-center gap-2"><Paperclip className="w-4 h-4 text-brand-primary"/> 1. Boleto e Comprovante (PDF)</span>
                    <span className="text-[10px] text-slate-500 font-normal">Boleto da última cobrança + comprovante de pagamento.</span>
                  </label>
                  <input 
                    type="file" 
                    accept=".pdf" 
                    onChange={(e) => handleFileChange(e, 'boletoComprovante')} 
                    className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100 cursor-pointer"
                    disabled={isProcessingEncerramento}
                  />
                  {arquivosEncerramento.boletoComprovante && <p className="text-xs text-green-600 font-medium mt-2 flex items-center gap-1"><CheckCircle className="w-3 h-3"/> {arquivosEncerramento.boletoComprovante.name}</p>}
                </div>

                {/* Recibo de Chaves */}
                <div className="border border-slate-200 rounded-xl p-4 bg-slate-50 relative group hover:border-brand-primary transition-colors">
                  <label className="flex flex-col text-sm font-semibold text-slate-700 mb-2 cursor-pointer">
                    <span className="flex items-center gap-2"><Paperclip className="w-4 h-4 text-brand-primary"/> 2. Recibo de Chaves (PDF)</span>
                    <span className="text-[10px] text-slate-500 font-normal">Recibo de entrega de chaves do imóvel.</span>
                  </label>
                  <input 
                    type="file" 
                    accept=".pdf" 
                    onChange={(e) => handleFileChange(e, 'reciboChaves')} 
                    className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100 cursor-pointer"
                    disabled={isProcessingEncerramento}
                  />
                  {arquivosEncerramento.reciboChaves && <p className="text-xs text-green-600 font-medium mt-2 flex items-center gap-1"><CheckCircle className="w-3 h-3"/> {arquivosEncerramento.reciboChaves.name}</p>}
                </div>
              </div>
            </div>

            <div className="p-5 border-t border-slate-100 bg-slate-50 flex justify-end gap-3">
              <button 
                onClick={fecharModalEncerramento}
                className="px-5 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-200 bg-white border border-slate-200 rounded-xl transition-colors shadow-sm"
                disabled={isProcessingEncerramento}
              >
                Cancelar
              </button>
              <button 
                onClick={confirmarEncerramento}
                disabled={isProcessingEncerramento || !arquivosEncerramento.boletoComprovante || !arquivosEncerramento.reciboChaves}
                className="flex items-center gap-2 px-5 py-2.5 text-sm font-bold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors disabled:opacity-50 shadow-sm"
              >
                {isProcessingEncerramento ? <Loader2 className="w-4 h-4 animate-spin" /> : <Ban className="w-4 h-4" />}
                {isProcessingEncerramento ? "Salvando..." : "Confirmar Encerramento"}
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default MinhaCarteiraPage;